import { render, staticRenderFns } from "./Cota.vue?vue&type=template&id=bb12e4c0&scoped=true&"
import script from "./Cota.vue?vue&type=script&lang=js&"
export * from "./Cota.vue?vue&type=script&lang=js&"
import style0 from "./Cota.vue?vue&type=style&index=0&id=bb12e4c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb12e4c0",
  null
  
)

export default component.exports